enum GrowthExperimentsEnum {
  NEW_INVOICE_CREATION_SAVE_BUTTONS = 'NEW_INVOICE_CREATION_SAVE_BUTTONS',
  NEW_DOC_TO_REVIEW_EXPERIENCE = 'NEW_DOC_TO_REVIEW_EXPERIENCE',
  TAX_CALCULATOR_IN_HOME_SCREEN = 'TAX_CALCULATOR_IN_HOME_SCREEN',
  PRO_GEWERBETREINDER_DISCOUNT = 'PRO_GEWERBETREINDER_DISCOUNT',
  FORCE_GEWERBETREIBENDER_PROVIDE_PROFESSION = 'FORCE_GEWERBETREIBENDER_PROVIDE_PROFESSION',
  HOME_TAX_LETTER_UPLOAD_HELPER = 'HOME_TAX_LETTER_UPLOAD_HELPER',
  AITA_ONLY_ENTRYPOINT = 'AITA_ONLY_ENTRYPOINT',
  PRICING_PAGE_V2 = 'PRICING_PAGE_V2',
  // todo: to be removed since it is already in the app and not ab tested
  ACCOUNTABLE_BANKING_ACTIVATION = 'Accountable Banking Activation',
  /** Web signup: treatment (B) redirects DE/BE banking-intent users to Accountable Banking signup after registration */
  POST_REGISTRATION_ACCOUNTABLE_BANKING_SIGNUP = 'POST_REGISTRATION_ACCOUNTABLE_BANKING_SIGNUP',

  // INTERCOM EXPERIMENTS
  INTERCOM_1 = 'INTERCOM_1',
  INTERCOM_2 = 'INTERCOM_2',
  INTERCOM_3 = 'INTERCOM_3',
  INTERCOM_4 = 'INTERCOM_4',
  INTERCOM_5 = 'INTERCOM_5',
  INTERCOM_6 = 'INTERCOM_6',
  INTERCOM_7 = 'INTERCOM_7',
  INTERCOM_8 = 'INTERCOM_8',
  INTERCOM_9 = 'INTERCOM_9',
  INTERCOM_10 = 'INTERCOM_10',
  INTERCOM_11 = 'INTERCOM_11',
  INTERCOM_12 = 'INTERCOM_12',
  INTERCOM_13 = 'INTERCOM_13',
  INTERCOM_14 = 'INTERCOM_14',
  INTERCOM_15 = 'INTERCOM_15',
  INTERCOM_16 = 'INTERCOM_16',
  INTERCOM_17 = 'INTERCOM_17',
  INTERCOM_18 = 'INTERCOM_18',
  INTERCOM_19 = 'INTERCOM_19',
  INTERCOM_20 = 'INTERCOM_20',
  INTERCOM_21 = 'INTERCOM_21',
  INTERCOM_22 = 'INTERCOM_22',
  INTERCOM_23 = 'INTERCOM_23',
  INTERCOM_24 = 'INTERCOM_24',
}

enum GrowthExperimentType {
  IN_APP = 'in-app',
  SIGNUP = 'signup',
}

enum ABTest {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
}

type GrowthExperimentDefinition = {
  name: GrowthExperimentsEnum;
  type: GrowthExperimentType;
  id: string;
  numOfGroups?: number;
};

export {
  GrowthExperimentsEnum,
  GrowthExperimentType,
  ABTest,
  GrowthExperimentDefinition,
};
